<template>
  <DefaultLayout>
    <div class="error-layout">
      <p class="code">
        {{ error.status || 404 }}
      </p>
      <p class="message">
        {{ error.message || 'Страница не найдена' }}
      </p>
      <BaseButton name="Вернуться назад" @click="goBack" />
    </div>
  </DefaultLayout>
</template>

<script setup lang="ts">
  import type { NuxtError } from '#app'
  import DefaultLayout from './layouts/default.vue'
  import { BaseButton } from '~/components/base-ui/buttons'

  const props = defineProps<{
    error: NuxtError
  }>()

  const router = useRouter()
  const { loggedError } = useErrors()

  loggedError(props.error)

  const goBack = () => {
    router.go(-1)
  }
</script>

<style scoped lang="scss">
  @use '~/assets/scss/layouts/error';
</style>
